import type { ControlStyleType, StyleTypePreset } from '@/types/dynamic-form';                                                        

/**
 * styleType에 따른 자동 프리셋 매핑
 * styleType을 선택하면 자동으로 controlSize와 variant가 설정됨    
 */
export const STYLETYPE_PRESETS: Record<ControlStyleType, StyleTypePreset> = {                                                         
  typeA: {
    controlSize: 'md',
    variant: 'default'
  },
  typeB: {
    controlSize: 'sm',
    variant: 'outline'
  },
  typeC: {
    controlSize: 'lg',
    variant: 'secondary'
  }
};

/**
 * styleType에 따라 controlSize와 variant를 자동으로 반환
 */
export function getStyleTypePreset(styleType?: ControlStyleType): StyleTypePreset {                                                   
  if (!styleType) {
    return STYLETYPE_PRESETS.typeA; // 기본값
  }
  return STYLETYPE_PRESETS[styleType] || STYLETYPE_PRESETS.typeA;  
}

/**
 * GlobalStyle에서 최종 controlSize와 variant를 계산
 * styleType이 있으면 그것을 우선하고, 없으면 직접 지정된 값을 사용
 */
export function resolveGlobalStyle(globalStyle?: {
  styleType?: ControlStyleType;
  controlSize?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outline' | 'secondary' | 'destructive' | 'ghost';                                                            
}): { controlSize: 'sm' | 'md' | 'lg'; variant: 'default' | 'outline' | 'secondary' | 'destructive' | 'ghost' } {                     
  if (globalStyle?.styleType) {
    const preset = getStyleTypePreset(globalStyle.styleType);      
    return {
      controlSize: globalStyle.controlSize || preset.controlSize,  
      variant: globalStyle.variant || preset.variant
    };
  }

  return {
    controlSize: globalStyle?.controlSize || 'md',
    variant: globalStyle?.variant || 'default'
  };
}

